<ng-container *ngIf="!this.env.USE_TAILWIND; else elseBlock">
    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>

            <ridango-ui-back-button (onBack)="back()"
                >{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}
            </ridango-ui-back-button>

            <div class="ticket">
                <rwidget-customer-account-edit-aside></rwidget-customer-account-edit-aside>
                <rwidget-customer-account-edit (onEditSuccess)="handleEditSuccess()"></rwidget-customer-account-edit>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #elseBlock>
    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>

            <ridango-ui-back-button (onBack)="back()"
                >{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}
            </ridango-ui-back-button>

            <div class="ticket">
                <rwidget-customer-account-edit-new
                    (onEditSuccess)="handleEditSuccess()"></rwidget-customer-account-edit-new>
            </div>
        </div>
    </div>
</ng-template>
